import React, { useState } from 'react';
import { MdAdd, MdDelete } from 'react-icons/md';
import { useLanguage } from '../../context/LanguageContext';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const selectStyle = {
    background: 'var(--bg-body)', border: '1px solid var(--border)',
    borderRadius: 6, color: 'var(--text-primary)', fontSize: 12,
    padding: '4px 6px', cursor: 'pointer'
};

// Bildirim alıcı listesi düzenleyici: [{ email, language }]
export default function RecipientListEditor({ value, onChange, disabled }) {
    const { t } = useLanguage();
    const [email, setEmail] = useState('');
    const [language, setLanguage] = useState('tr');
    const [error, setError] = useState('');

    const add = () => {
        const normalized = email.trim().toLowerCase();
        if (!EMAIL_RE.test(normalized)) {
            setError(t('alertSettings.invalidEmail'));
            return;
        }
        if (value.some(r => r.email === normalized)) {
            setError(t('alertSettings.duplicateEmail'));
            return;
        }
        onChange([...value, { email: normalized, language }]);
        setEmail('');
        setError('');
    };

    return (
        <div>
            {value.length === 0 ? (
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>{t('alertSettings.noRecipients')}</div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 10 }}>
                    {value.map((r, i) => (
                        <div key={r.email} style={{
                            display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px',
                            background: 'var(--bg-body)', border: '1px solid var(--border)', borderRadius: 8
                        }}>
                            <span style={{ flex: 1, fontSize: 13, wordBreak: 'break-all' }}>{r.email}</span>
                            <select
                                value={r.language}
                                disabled={disabled}
                                onChange={(e) => onChange(value.map((x, j) => j === i ? { ...x, language: e.target.value } : x))}
                                style={selectStyle}
                            >
                                <option value="tr">TR</option>
                                <option value="en">EN</option>
                            </select>
                            <button
                                className="btn btn-danger btn-sm btn-icon"
                                disabled={disabled}
                                onClick={() => onChange(value.filter((_, j) => j !== i))}
                                style={{ width: 28, height: 28 }}
                                title={t('common.delete')}
                            >
                                <MdDelete size={14} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <input
                    className="form-input"
                    type="email"
                    value={email}
                    disabled={disabled}
                    placeholder={t('alertSettings.emailPlaceholder')}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
                    style={{ flex: '1 1 200px', minWidth: 0 }}
                />
                <select value={language} onChange={(e) => setLanguage(e.target.value)} disabled={disabled} style={selectStyle}>
                    <option value="tr">TR</option>
                    <option value="en">EN</option>
                </select>
                <button className="btn btn-secondary btn-sm" onClick={add} disabled={disabled || !email.trim()}>
                    <MdAdd /> {t('alertSettings.addRecipient')}
                </button>
            </div>
            {error && <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 6 }}>{error}</div>}
        </div>
    );
}
